import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FilterInterface, Shape} from '../../interfaces/filter.interface';
import {Store} from '@ngrx/store';
import {first} from 'rxjs/operators';
import {SearchFilterService} from '../../services/search-filter.service';
import {Subscription} from 'rxjs';
import {SelectColors, SelectProductSections, SelectShapes} from "../../store/actions/filter.actions";

@Component({
  selector: 'app-shape-filter',
  templateUrl: './shape-filter.component.html',
  styleUrls: ['./shape-filter.component.scss']
})
export class ShapeFilterComponent implements OnInit {
  private subscriptions: Subscription = new Subscription();

  shapeSelected: Shape = {};
  @Output() shapesEvent = new EventEmitter<Shape>();

  constructor(private store: Store<{ filter: FilterInterface }>, private searchFilterService: SearchFilterService) {
  }

  ngOnInit(): void {
    this.store.select('filter').subscribe((data) => {
      this.shapeSelected = {...data.tags.shape};
    });

    const resetFilter = this.searchFilterService.resetFilters$.subscribe((reset) => {
      if (reset) {
        this.shapeSelected = {};
        this.store.dispatch(SelectShapes(this.shapeSelected));
      }
    });
  }

  handleShapeTypeSelected(form: string): void {
    this.shapeSelected[form] = !this.shapeSelected[form];
    // this.shapesEvent.emit(this.shapeSelected);
    this.store.dispatch(SelectShapes(this.shapeSelected));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
